<template>
  <div class="components-dialog">
    <a-modal
      :width="900"
      :title="form.id ? (form.disabled ? '查看' : $t('update')) : $t('create')"
      :visible="dialog"
      :maskClosable="false"
      @cancel="cancel"
    >
      <template slot="footer">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="confirm"
        >
          提交
        </a-button>
      </template>
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <div class="item">
          <a-form-model-item label="应用id" prop="clientId">
            <a-input
              :disabled="form.disabled"
              v-model="form.clientId"
              placeholder="请输入应用id"
              :maxLength="maxLength"
            />
          </a-form-model-item>
          <a-form-model-item label="应用密钥" prop="clientSecret">
            <a-input
              :disabled="form.disabled"
              v-model="form.clientSecret"
              placeholder="请输入应用密钥"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="授权类型" prop="grantTypes">
            <a-checkbox-group
              v-model="form.grantTypes"
              :disabled="form.disabled"
            >
              <a-checkbox
                v-for="(item, index) in dictList"
                :key="index"
                :value="item.dictKey"
              >
                {{ item.dictValue }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item label="授权范围" prop="scope">
            <a-input
              :disabled="form.disabled"
              v-model="form.scope"
              placeholder="请输入授权范围"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="令牌秒数" prop="accessTokenValidity">
            <a-input-number
              id="acc"
              style="width: 100%"
              v-model="form.accessTokenValidity"
              @change="onacc"
              placeholder="请输入令牌秒数"
              :min="1"
              :max="100000000000"
              :disabled="form.disabled"
            />
          </a-form-model-item>
          <a-form-model-item label="刷新秒数" prop="refreshTokenValidity">
            <a-input-number
              id="refresh"
              style="width: 100%"
              v-model="form.refreshTokenValidity"
              @change="onrefresh"
              placeholder="请输入刷新秒数"
              :min="1"
              :max="100000000000"
              :disabled="form.disabled"
            />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="回调地址" prop="webServerRedirectUri">
            <a-input
              :disabled="form.disabled"
              v-model="form.webServerRedirectUri"
              placeholder="请输入回调地址"
              :maxLength="maxLength"
            />
          </a-form-model-item>
          <a-form-model-item label="资源集合" prop="resourceIds">
            <a-input
              :disabled="form.disabled"
              v-model="form.resourceIds"
              placeholder="请输入资源集合"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item label="权限" prop="authorities">
            <a-input
              :disabled="form.disabled"
              v-model="form.authorities"
              placeholder="请输入权限"
              :maxLength="maxLength"
            />
          </a-form-model-item>
          <a-form-model-item label="自动授权" prop="autoapprove">
            <a-input
              :disabled="form.disabled"
              v-model="form.autoapprove"
              placeholder="请输入自动授权"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
        <div class="item row">
          <a-form-model-item label="附加说明" prop="additionalInformation">
            <a-input
              :disabled="form.disabled"
              v-model="form.additionalInformation"
              placeholder="请输入附加说明"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>
<style lang="less">
.item.row .ant-form-item {
  width: 100%;
}
.item {
  display: flex;
  .ant-form-item {
    width: 50%;
    display: flex;
    .ant-form-item-label {
      width: 90px;
      text-align: right;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .ant-checkbox-wrapper {
    width: 50%;
    margin: 0;
  }
}
</style>
<script>
import { AuthClientServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const api = new AuthClientServiceProxy();
const options = {
  submit: api.submit.bind(api),
};
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    form: Object,
    dictList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rules: {
        clientId: [
          { required: true, message: "客户端id必填", trigger: "blur" },
        ],
        clientSecret: [
          { required: true, message: "应用密钥必填", trigger: "blur" },
        ],
        grantTypes: [
          { required: true, message: "授权类型必选", trigger: "change" },
        ],
        scope: [{ required: true, message: "授权范围必填", trigger: "blur" }],
        accessTokenValidity: [
          { required: true, message: "令牌秒数必填", trigger: "blur" },
        ],
        refreshTokenValidity: [
          { required: true, message: "刷新秒数必填", trigger: "blur" },
        ],
        webServerRedirectUri: [
          { required: true, message: "回调地址必填", trigger: "blur" },
        ],
      },
      ...options,
      maxLength: 30,
      loading: false,
    };
  },
  methods: {
    onacc(e) {
      this.form.accessTokenValidity = e;
    },
    onrefresh(e) {
      this.form.refreshTokenValidity = e;
    },
    cancel() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    confirm() {
      if (this.loading) {
        return;
      }
      if (this.form.disabled) {
        return this.$emit("close");
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.authorizedGrantTypes = this.form.grantTypes.join(",");
          this.submit(this.form).then((res) => {
            this.$emit("update");
            this.loading = false;
          }).catch(_=>{
            this.loading = true;
          });
        }
      });
    },
  },
};
</script>
